import { render } from "./RegisterManager.vue?vue&type=template&id=1a53a5cf&scoped=true"
import script from "./RegisterManager.vue?vue&type=script&lang=js"
export * from "./RegisterManager.vue?vue&type=script&lang=js"

import "./RegisterManager.vue?vue&type=style&index=0&id=1a53a5cf&scoped=true&lang=css"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a53a5cf"]])

export default __exports__